// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';


// Stateless components

export function PageTitle(props) {

    //
    // Helpers
    //
    
    function getPageTitle(context) {
        var current_page = context['current_page'];
        var current_page_data = context['helpers'].getPageBySlug(current_page);

        if (current_page_data) {
            var ia_level = current_page_data['ia_level'];

            var page_data = null;

            if (ia_level === 1) {
                page_data = current_page_data;
            } else {
                var parent_page = current_page_data['parent'];
                page_data = context['helpers'].getPageBySlug(parent_page);
            }

            if (page_data) {
                var page_title = page_data['name'];

                if (typeof(page_title) !== 'undefined') {
                    return page_title;
                }
            }
        }
        

        return "";
    }


    //
    // Render
    //

    function renderPageTitle(context) {
        var page_title = getPageTitle(context);

        return <h1 className="page-header__title">{page_title}</h1>;
    }

    return (
        <PortalContext.Consumer>
            {renderPageTitle}
        </PortalContext.Consumer>
    );

};
